export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-espresso/10 bg-sand py-5" data-testid="editorial-marquee" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center font-serif text-xl italic text-espresso/70 sm:text-2xl">
          <span className="px-6">{item}</span>
          <span className="h-2 w-2 shrink-0 rounded-full bg-brand" />
        </span>
      ))}
    </div>
  </div>
);
